<template>
  <div class="zhihu-index-page">
    <main class="zhihu-main">
      <el-row :gutter="24" type="flex" justify="center">

        <!-- 左侧：问题列表与分页 -->
        <el-col :xs="24" :sm="24" :md="16" :lg="14" class="main-column">

          <div class="feed-header">
            <h2>知乎精选问题</h2>
          </div>

          <!-- 问题列表卡片区域 -->
          <div v-for="item in questionList" :key="item.questionId" class="question-item-card">
            <!-- 标签 -->
            <div class="tags-container" v-if="item.tags && item.tags.length">
              <el-tag v-for="(tag, index) in item.tags" :key="index" size="mini" effect="plain" class="question-tag">
                {{ tag }}
              </el-tag>
            </div>

            <!-- 问题标题（点击跳转至详情页，使用动态路由） -->
            <router-link :to="`/question/${item.questionId}`" class="question-title-link">
              <h3 class="question-title">{{ item.title }}</h3>
            </router-link>

            <!-- 作者摘要信息 -->
            <div class="author-snippet-bar" v-if="item.author">
              <el-avatar :size="24" :src="item.author.avatar" class="snippet-avatar" />
              <span class="snippet-author-name">{{ item.author.name }}：</span>
              <span class="snippet-headline" v-if="item.author.headline">{{ item.author.headline }}</span>
            </div>

            <!-- 问题摘要 (支持富文本清洗) -->
            <div class="question-excerpt" v-html="formatRichContent(item.excerpt || item.detail)" />
          </div>

          <!-- Element UI 分页组件 -->
          <div class="pagination-container" v-if="totalSize > 0">
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :current-page.sync="queryInfo.pn"
              :page-size="queryInfo.pageSize"
              :total="totalSize"
              @current-change="handlePageChange"
            />
          </div>

        </el-col>

        <!-- 右侧：边栏 (Sidebar) -->
        <el-col :xs="0" :sm="0" :md="7" :lg="6" class="sidebar-column">
          <div class="sidebar-card">
            <div class="card-title">热门推荐</div>
            <ul class="related-list">
              <li v-for="(item, index) in relatedQuestions" :key="index">
                <a href="javascript:;">{{ item.title }}</a>
                <span class="answer-num">{{ item.answers }} 回答</span>
              </li>
            </ul>
          </div>
        </el-col>

      </el-row>
    </main>
  </div>
</template>

<script>
import { getQuestions } from '@/api/zhihu'

export default {
  name: 'ZhihuIndex',
  data() {
    return {
      // 查询参数
      queryInfo: {
        pn: 1,
        pageSize: 10
      },
      totalSize: 0,
      questionList: [], // 对应接口中的 list
      relatedQuestions: [
        { title: '如何看待当前大学城安全管理与治安防范？', answers: '324' },
        { title: '面对突发恶性事件，普通人应该如何最大限度保护自己？', answers: '512' },
        { title: '社会心理压力增大时，如何进行自我心理调节？', answers: '1.2w' }
      ]
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取问题列表数据
    getData() {
      const params = {
        pn: this.queryInfo.pn,
        pageSize: this.queryInfo.pageSize
      }

      getQuestions(params).then(resp => {
        if (resp.code === 0 && resp.data) {
          this.questionList = resp.data.list || []
          this.totalSize = resp.data.totalSize || 0
          // 如果后端返回了 pageNumber，可以同步更新当前页
          if (resp.data.pageNumber) {
            this.queryInfo.pn = resp.data.pageNumber
          }
        }
      }).catch(err => {
        console.error('获取问题列表失败', err)
      })
    },

    // 页码改变触发事件
    handlePageChange(newPage) {
      this.queryInfo.pn = newPage
      this.getData()
      // 切换页码后滚动回页面顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    // 清洗知乎富文本：提取真实的图片地址
    formatRichContent(html) {
      if (!html) return ''

      const div = document.createElement('div')
      div.innerHTML = html

      // 1. 处理懒加载图片
      const lazyImages = div.querySelectorAll('img.lazy, img[data-actualsrc], img[data-src]')
      lazyImages.forEach(img => {
        const realSrc = img.getAttribute('data-actualsrc') || img.getAttribute('data-src')
        if (realSrc) {
          img.setAttribute('src', realSrc)
        }
        img.classList.remove('lazy')
      })

      // 2. 释放 noscript 标签中的真实图片
      const noscripts = div.querySelectorAll('noscript')
      noscripts.forEach(noscript => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = noscript.textContent || noscript.innerHTML
        const noscriptImg = tempDiv.querySelector('img')
        if (noscriptImg && noscript.parentNode) {
          noscript.parentNode.replaceChild(noscriptImg, noscript)
        }
      })

      return div.innerHTML
    }
  }
}
</script>

<style scoped>
.zhihu-index-page {
  background-color: #f6f6f6;
  min-height: 100vh;
  color: #121212;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding-bottom: 40px;
}
.zhihu-main {
  max-width: 1030px;
  margin: 10px auto 0;
  padding: 0 10px;
}
.feed-header {
  background: #fff;
  padding: 15px 20px;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(18, 18, 18, 0.04);
  margin-bottom: 10px;
}
.feed-header h2 {
  font-size: 16px;
  margin: 0;
  font-weight: 600;
}
.question-item-card {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(18, 18, 18, 0.04);
  padding: 20px;
  margin-bottom: 10px;
}
.question-tag {
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: rgba(0, 102, 255, 0.1);
  color: #0066ff;
  border: none;
}
.question-title-link {
  text-decoration: none;
}
.question-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: #121212;
  margin: 8px 0 12px 0;
}
.question-title-link:hover .question-title {
  color: #0066ff;
}
.author-snippet-bar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
}
.snippet-avatar {
  margin-right: 8px;
}
.snippet-author-name {
  font-weight: 600;
  color: #444;
}
.snippet-headline {
  color: #8590a6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.question-excerpt {
  font-size: 14px;
  line-height: 1.6;
  color: #121212;
}
.question-excerpt >>> p {
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制摘要最多显示3行 */
  overflow: hidden;
}
.question-excerpt >>> img {
  max-width: 100%;
  height: auto !important;
  border-radius: 4px;
  margin: 10px 0;
}

/* 分页组件容器样式 */
.pagination-container {
  background: #fff;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(18, 18, 18, 0.04);
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

/* 侧边栏卡片 */
.sidebar-card {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(18, 18, 18, 0.04);
  padding: 20px;
  margin-bottom: 10px;
}
.sidebar-card .card-title {
  font-size: 15px;
  font-weight: 600;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
}
.related-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.related-list li {
  margin-bottom: 12px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
}
.related-list a {
  color: #121212;
  text-decoration: none;
  flex: 1;
  margin-right: 10px;
}
.related-list a:hover {
  color: #0066ff;
}
.related-list .answer-num {
  color: #8590a6;
  white-space: nowrap;
}
</style>
